import { useEffect } from "react";
import { ProjectUpload } from "../ProjectUpload.jsx";
import { useFormDispatch } from "../../FormContext.jsx";
import styles from "../../showroomForm.css.js";

const UploadProject = ({
  fieldKey,
  errors,
  validateFile,
  formData,
  setFormData,
  setErrors,
  required,
  description,
  validate,
  label,
}) => {
  const dispatch = useFormDispatch();

  const value = formData[fieldKey];

  useEffect(() => {
    dispatch({ type: "updateField", [fieldKey]: value });
  }, [value, fieldKey, dispatch]);

  /**
   * Clears the data and errors associated with this form field.
   */
  const clearDataAndErrorsForField = () => {
    // Clear own data
    if (value) {
      setFormData({ ...formData, [fieldKey]: null });
    }
    // Clear own error
    if (errors[fieldKey]) {
      const updatedErrors = { ...errors };
      delete updatedErrors[fieldKey];
      setErrors({ ...updatedErrors });
    }
  };

  return (
    <div className={styles.enhancedCompContainer}>
      <ProjectUpload
        validate={validate}
        label={label}
        description={description}
        fieldKey={fieldKey}
        formData={formData}
        setFormData={setFormData}
        error={errors[fieldKey]}
        validateFile={validateFile}
        required={required}
        onTabChange={() => clearDataAndErrorsForField()}
      />
    </div>
  );
};

export default UploadProject;
